
import { windowHeight } from 'bits/browser'
import { Component, Prop, Vue } from 'bits/vue'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'
import OzDrawerStatic from 'library/v4/components/OzDrawerStatic.vue'

@Component({ components: { OzDrawerStatic, OzContainedButton } })
export default class OzDrawerConfirmationDialog extends Vue {
  windowHeight = windowHeight

  /**
   * Icon.
   */
  @Prop({ default: null }) iconSrc!: string | null

  /**
   * Icon alt text.
   */
  @Prop({ default: 'icon' }) iconAlt!: string

  /**
   * Title.
   */
  @Prop({ required: true }) title!: string

  /**
   * Body.
   */
  @Prop() body?: string

  /**
   * Confirm button text.
   */
  @Prop() confirmButtonText?: string

  /**
   * Cancel button text.
   */
  @Prop() cancelButtonText?: string

  /**
   * Determines whether the modal should fade in when opened
   */
  @Prop({ default: true }) shouldFadeIn!: boolean

  get buttons() {
    return [
      /**
       * Emits events passed in via the `buttons` prop.
       * @event confirm
       */
      {
        text: this.confirmButtonText || this.__('Continue'),
        emit: 'confirm',
        colorScheme: OzContainedButtonColorScheme.Primary,
        testId: 'confirmButton',
      },
      /**
       * Emits events passed in via the `buttons` prop.
       * @event cancel
       */
      {
        text: this.cancelButtonText || this.__('Cancel'),
        emit: 'cancel',
        colorScheme: OzContainedButtonColorScheme.Secondary,
        testId: 'cancelButton',
      },
    ]
  }

  select(buttonEvent): void {
    /**
     * Emits events passed in via the `buttons` prop.
     * @event buttonEvent
     */
    this.$emit(buttonEvent)
  }
}
